module.exports = __webpack_public_path__ + "img/sharebanner.5dc7d32d.png";